'use client';

import {
  Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse,
  Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex,
} from '@woonstad/api-client-stadswonen-aanbod';
import { trackEvent } from '@woonstad/modules-google-tag-manager';
import { useEffect } from 'react';

type Props = {
  complex?: Woonstad_Foundation_Portfolio_Api_Models_WRM_IndexedComplex;
  complexAanbod?: Woonstad_Foundation_Portfolio_Api_Controllers_WRM_StadswonenAdvertisementResponse;
};

export const TrackComplex = ({
  complex,
  complexAanbod,
}: Props) => {
  useEffect(() => {
    trackEvent({
      event: 'view_woongebouw',
      item_locatie: 'Woongebouw Detailpagina',
      woongebouw_regio: complex?.Address?.Region ?? undefined,
      woongebouw_district: complex?.Address?.District ?? undefined,
      woongebouw_naam: complex?.ComplexInfo?.Name ?? undefined,
      available: complexAanbod?.items ? complexAanbod?.items?.length : undefined,
      doelgroep: complex?.ComplexDetailInfo?.TargetGroups
        ? Object.values(complex?.ComplexDetailInfo?.TargetGroups)
        : undefined,
    });
  });

  return null;
};
